import { trimPathRight } from "@tanstack/react-router";
import type { AnyRouter } from "@tanstack/react-router";

export const getRouteTemplate = ({
  matches,
  location,
}: AnyRouter["state"]): string | undefined => {
  // Home renders outside the route tree and must never count as not found.
  if (
    location.pathname !== "/" &&
    matches.some((match) => match.globalNotFound)
  )
    return "/not-found";

  const fullPath = matches[matches.length - 1]?.fullPath;

  return fullPath && trimPathRight(fullPath);
};
